module.exports = __webpack_public_path__ + "static/media/dummy1.26bd3ac0.jpeg";